import { Grid, Tooltip } from "@mui/material"
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile"
import { useState } from "react";

export const ParametroFilterInput = ({ parametro, onParametrosValuesChange, disableFilters, parametrosValues }) => {

    const [show, setShow] = useState(false);

    const hideTooltip = () => setShow(false);

    return <Tooltip
        title={parametro.observacion || ''}
        aria-label={parametro.observacion || ''}
        open={show}
        disableHoverListener
        onMouseEnter={() => setShow(true)}
        onMouseLeave={hideTooltip}
    >
        <Grid
            size={{ xs: 12, md: 6, lg: 4, xl: 4 }}
            onMouseDown={hideTooltip}
            onFocus={hideTooltip}
        >
            <RenderInputByTypeMobile
                input={{
                    type: parametro.type,
                    displayName: parametro.displayName,
                    name: parametro.name,
                    disabled: disableFilters,
                    required: parametro.required,
                    options: parametro.options || []
                }}
                value={parametrosValues[parametro.name] ?? ''}
                handleChange={onParametrosValuesChange}
            />
        </Grid>
    </Tooltip>
}